module.exports = __webpack_public_path__ + "img/Singapore.3e618338.png";